import axios from 'axios';
import SecurityModule from '@/store/modules/SecurityModule';
// import Vue from 'vue';
// import VueRouter from 'vue-router';

const instance = axios.create({
    baseURL: (window.location.hostname.includes('.vpc') ? process.env.VUE_APP_API_BASE_URL.replace('.fr', '.vpc') : process.env.VUE_APP_API_BASE_URL) || 'https://localhost:8000',
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },

});

if (null !== SecurityModule.token) {
    instance.defaults.headers.common.Authorization = `Bearer ${SecurityModule.token}`;
    // instance.defaults.headers.common.withCredentials = true;
}

const requestInterceptorId = instance.interceptors.request.use(
    (configuration) => {
        return configuration;
    },
);

// const responseInterceptorId = instance.interceptors.response.use(
//     (response) => {
//         // console.log("Response interceptors", response);
//         return response;
//     },
//     (error) => {
//         // console.log("Axios errors", error.response.data);
//
//         const data = error.response.data;
//         if (
//             data.code &&
//             data.code === 401 &&
//             data.message &&
//             data.message === 'Expired JWT Token'
//         ) {
//             // delete instance.defaults.headers.common.Authorization;
//             //
//             // SecurityModule.setUser(null);
//             // SecurityModule.setToken(null);
//             // // window.EventManager.fire('token_expired');
//         }
//
//         return Promise.reject(error);
//     },
// );


instance.interceptors.request.eject(requestInterceptorId);
// instance.interceptors.response.eject(responseInterceptorId);

export default instance;
